import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
// 模块引入
const modulesFiles = require.context('./modules', true, /\.js$/)

const originalPush = Router.prototype.push;
// 重复路由点击报错处理
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

/**
 * 参数说明
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
// 模块数据集成
let modulesArr = [];
modulesFiles.keys().forEach((modules) => {
  // const moduleName = modules.replace(/^\.\/(.*)\.\w+$/, '$1');
  const moduleContent = modulesFiles(modules);
  Object.keys(moduleContent).forEach((key) => {
    let list = moduleContent[key] || [];
    modulesArr.push(...list)
  });
})

export const asyncRoutes = [
  ...modulesArr,
  //{ path: '*', redirect: '/404', hidden: true },
]

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/home',
    hidden: true
  },
  {
    path: '/home',
    component: Layout,
    name: 'home',
    meta: { title: '首页', icon: 'icon-chanpinPIguanli-01', affix: true },
    children: [
      {
        path: '/home',
        component: () => import('@/views/Home'),
        name: 'home',
        meta: { title: '首页', affix: true }
      },
      {
        path: '/preview',
        component: () => import('@/views/Preview'),
        name: 'preview',
        meta: { title: '在线预览', affix: false },
        hidden: true
      },
      {
        path: '/profile',
        component: () => import('@/views/System/Profile'),
        name: 'UserProfile',
        meta: { title: '个人资料', affix: false, needBack: true },
        hidden: true
      },
      {
        path: '/system/contacts',
        component: () => import('@/views/System/Contacts'),
        name: 'SystemContacts',
        meta: { title: '企业通讯录', affix: false },
        hidden: true
      },
      {
        path: '/message',
        component: () => import('@/views/Message/List'),
        name: 'UserMessageList',
        meta: { title: '消息中心', affix: false },
        hidden: true
      },
      {
        path: '/message/:id',
        component: () => import('@/views/Message/Detail'),
        name: 'UserMessageDetail',
        meta: { title: '消息详情', affix: false, needBack: true },
        hidden: true
      },
    ]    
  },
  //...modulesArr,
  // { path: '*', redirect: '/404', hidden: true },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }  
]

const createRouter = () => new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
